import React, {useEffect, useState} from 'react';
import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs } from 'firebase/firestore';

import ProjectCard from './ProjectCard';

/**
 * Renders a grid of projects based on filters and search query.
 * 
 * @param {Object} filters - The filters to apply to the projects.
 * @param {string} filters.technology - The technology filter.
 * @param {string} filters.type - The type filter.
 * @param {string} searchQuery - The search query to filter projects by name.
 * @returns {JSX.Element} The rendered project grid.
 */
export default function ProjectGrid({filters, searchQuery}) {
    const [projekty, setProjekty] = useState([]);

    const firebaseConfig = {
        apiKey: "AIzaSyA9awgIBkxiIbZSsQzsPRlzOnI14ZhceH0",
        authDomain: "portfolio-c10d1.firebaseapp.com",
        projectId: "portfolio-c10d1",
        storageBucket: "portfolio-c10d1.appspot.com",
        messagingSenderId: "169094375046",
        appId: "1:169094375046:web:d45e07e8a74fa30b0c9307"
    };

    const projekty_array = [];

    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    const db = getFirestore(app);

    useEffect(() => {
        const fetchData = async () => {
            const projekty_array = [];
            const querySnapshot = await getDocs(collection(db, "projekty"));
            querySnapshot.forEach((doc) => {
                const dataWithId = { ...doc.data(), id: doc.id };
                projekty_array.push(dataWithId);
            });
    
            // Filter duplicates before setting the state
            const uniqueProjekty = projekty_array.filter((projekt, index, self) =>
                index === self.findIndex((t) => (
                    t.nazwa === projekt.nazwa
                ))
            );
            setProjekty(uniqueProjekty);
        };
        fetchData();
        console.log(projekty[0]);
    }, []);

    useEffect(() => {
        console.log('Filters changed');
    }, [filters]);

    const filterProjekty = projekty.filter((projekt) => {
        let matchesTechnology = true;
        let matchesType = true;
    
        if (filters.technology) {
            matchesTechnology = filters.technology.includes(projekt.technologia);
        }
    
        if (filters.type) {
            matchesType = projekt.typ === filters.type;
        }

        if (searchQuery) {
            matchesType = projekt.nazwa.toLowerCase().includes(searchQuery.toLowerCase());
        }
    
        return matchesTechnology && matchesType;
    });
    
    return (
        <section className='w-full flex-auto'>
            <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-5'>
                {filterProjekty.map((projekt, index) => (
                    <ProjectCard
                        key={index}
                        imagesrc={projekt.zdjecie}
                        projectTitle={projekt.nazwa}
                        projectDesc={projekt.opis}
                        link={"/portfolio/projects/" + projekt.id}
                    />
                ))}
            </div>
        </section>
    );

}